import type { UseFormReturn } from "react-hook-form"
import type { FieldConfig } from "./config"

export const countries = [
  { value: "us", label: "United States" },
  { value: "ca", label: "Canada" },
  { value: "uk", label: "United Kingdom" },
  { value: "au", label: "Australia" },
  { value: "in", label: "India" },
  { value: "jp", label: "Japan" },
  { value: "fr", label: "France" },
  { value: "de", label: "Germany" },
]

const productTypes = [
  { value: "9", label: "Sale", type: 'buy' },
  { value: "9", label: "Enchashment", type: 'sell' },
  // { value: "16", label: "Reload", type: 'buy' },
  // { value: "16", label: "Unload", type: 'buy' },
  { value: "16", label: "New card issuance", type: 'buy' },
]

export const travelPurposes = [
  { value: "Education", label: "Education" },
  { value: "Tourism", label: "Tourism" },
]

const currenciesList = [
  { value: "usd", label: "USD" },
  { value: "eur", label: "EUR" },
  { value: "gbp", label: "GBP" },
  { value: "jpy", label: "JPY" },
  { value: "aud", label: "AUD" },
  { value: "cad", label: "CAD" },
]
export const customDestinationFields: FieldConfig[] = [
  {
    type: "select",
    name: "destination.purposeOfTravel",
    label: "Purpose of Travel",
    placeholder: "Select purpose of travel",
    options: travelPurposes,
    required: true,
    valueType: 'single_string'
  },
  {
    type: 'select',
    name: "destination.destination",
    label: "Where do you want to go? (Destination)",
    placeholder: "Search and select country",
    options: countries,
    required: true,
    valueType: 'single_string'
  },
  {
    type: "date",
    name: "destination.dateRange.start_date",
    label: "Journey Start Date",
    placeholder: "Select start date",
    required: false,
  },
  {
    type: "date",
    name: "destination.dateRange.end_date",
    label: "Journey End Date",
    placeholder: "Select end date",
    required: false,
  },
]

const cardTypes = [
  { value: "multicurrency", label: "Multi-Currency" },
  { value: "singlecurrency", label: "Single Currency" },
]

export const productConfig: FieldConfig[] = [
  {
    type: 'select',
    name: 'productType',
    label: 'Select Product',
    options: productTypes,
    required: true,
  },
  {
    type: 'select',
    name: 'cardType',
    label: 'Select Card Type',
    options: cardTypes,
    required: false,
  },
  {
    type: 'select',
    name: 'currencies',
    label: 'Select Currencies*',
    options: currenciesList,
    required: true,
  },
]

export const customerConfig: FieldConfig[] = [
  {
    type: 'select',
    name: 'mobileNumber',
    label: 'What is the mobile number of customer?',
    options: productTypes,
    required: true,
  },
  {
    type: 'text',
    name: 'fullName',
    label: 'What is the full name of the customer?',
    required: true,
  },
  {
    type: 'email',
    name: 'email',
    label: 'What is the email ID of the customer?',
    required: false,
  },
  {
    type: 'text',
    name: 'pan',
    label: "What is customer's PAN?",
    required: false,
  },
]

export const customerSingleConfig: FieldConfig[] = [
  {
    type: 'select',
    name: 'customers.0.mobileNumber',
    label: 'What is the mobile number of customer?',
    options: productTypes,
    required: true,
  },
  {
    type: 'text',
    name: 'customers.0.fullName',
    label: 'What is the full name of the customer?',
    required: true,
  },
  {
    type: 'email',
    name: 'customers.0.email',
    label: 'What is the email ID of the customer?',
    required: false,
  },
  {
    type: 'text',
    name: 'customers.0.pan',
    label: "What is customer's PAN?",
    required: false,
  },
]

type FormStep = 'forex' | 'visa' | 'travel'

export const step1: Record<FormStep, FieldConfig[]> = {
  'forex': customDestinationFields,
  'visa': customDestinationFields,
  'travel': customDestinationFields,
}

export const step2Singal: Record<FormStep, FieldConfig[]> = {
  'forex': customerSingleConfig,
  'visa': customerSingleConfig,
  'travel': customerSingleConfig,
}

export const step2: Record<FormStep, FieldConfig[]> = {
  'forex': customerConfig,
  'visa': customerConfig,
  'travel': customerConfig,
}

export const products: Record<FormStep, FieldConfig[]> = {
  'forex': productConfig,
  'visa': productConfig,
  'travel': productConfig,
}